import React from 'react';
import { Box, Svg, Text } from '@hopskipdrive/react-components';

import { Container } from './styles';

export interface ServerErrorProps {
  statusCode: number;
  errorMessage: string;
}

export const ServerError: React.FC<ServerErrorProps> = ({ statusCode, errorMessage }) => {
  return (
    <Container>
      <Box display="flex" alignItems="flex-start" flexDirection="column" gap="26px">
        <Svg icon="hsd-logo" width={104} height={93} alt="HopSkipDrive logo" />
        <Box display="flex">
          <Text variant="h1" textColor="primaryText" fontWeight={600} mr={4}>
            {`Error ${statusCode}.`}
          </Text>
          <Text variant="h1" textColor="secondaryText" fontWeight={600}>
            This page is not working
          </Text>
        </Box>
        <Text variant="body1" textColor="secondaryText" fontWeight={400}>
          {errorMessage || 'The server is not able to handle this request.'}
        </Text>
      </Box>
    </Container>
  );
};
